import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';

import { BusinessModifierGroupManagerHandler } from '../../providers/business-modifier-group-handler';
import { BusinessModifierGroupManagerPage } from '../business-modifier-group-manager/business-modifier-group-manager';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-modifier-group-list',
  templateUrl: 'business-modifier-group-list.html',
})
export class BusinessModifierGroupListPage {
	groups: any;
	hasGroups: boolean = false;
	filePath: any;
	loader: any;
	isLoading: boolean = false;

	loadingMsg: any = "Loading...";
	isRefreshing: boolean = false;
	lastRequestReturnedValues: boolean = false;

	params: any = {
		page: 1,
		size: 20,
		cb: null
	}

  	constructor(
  		public navCtrl: NavController, 
		public navParams: NavParams,
		public handler: BusinessModifierGroupManagerHandler,
		public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public globals: Globals,
		) {
		this.filePath = this.globals.fileUrl;
  	}

  	ionViewWillEnter() {
		this.load(null);
	}	

	doRefresh(refresher) {
		this.isRefreshing = true;

		this.load(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
			infiniteScroll.complete();
			return;
		} 

		this.isRefreshing = true;

		this.params.page++;

		this.load(()=>{
			this.isRefreshing = false;
			
			infiniteScroll.complete();
		});
	}		

	create(){
	    this.navCtrl.push(BusinessModifierGroupManagerPage, {
	      group: {}
	    });		
	}

	manage($e, group){
	    this.navCtrl.push(BusinessModifierGroupManagerPage, {
	      group: group
	    });				
	}

	load(cb){
		this.isLoading = (!this.isRefreshing) ? true : false;

		this.params.cb = (groups)=>{
			this.groups = groups;

			this.hasGroups = this.groups.length>0;

			this.isLoading = false;

			if(typeof cb == "function")
				cb()			
		}
		
		this.handler.getModifierGroups(this.params)
	}

}



// WEBPACK FOOTER //
// ./src/pages/business-modifier-group-list/business-modifier-group-list.ts